import { render, staticRenderFns } from "./MerchantUpdate.vue?vue&type=template&id=2dc1e389"
import script from "./MerchantUpdate.vue?vue&type=script&lang=js"
export * from "./MerchantUpdate.vue?vue&type=script&lang=js"
import style0 from "./MerchantUpdate.vue?vue&type=style&index=0&id=2dc1e389&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports